import { isDateVariableName } from "@features/dynamic-variables/date-variable/date-resolver";

export type VariableControlKind =
  | "input"
  | "number"
  | "iframe"
  | "select"
  | "multiselect"
  | "color"
  | "date"
  | "media"
  | "video"
  | "rich-text"
  | "ai"
  | "list"
  | "data";

const CONTROL_BY_TYPE: Record<string, VariableControlKind> = {
  input: "input",
  number: "number",
  iframe: "iframe",
  select: "select",
  multiselect: "multiselect",
  color: "color",
  date: "date",
  media: "media",
  image: "media",
  "image-video": "media",
  video: "video",
  "editor-basic": "rich-text",
  ai: "ai",
  list: "list",
  data: "data",
};

/**
 * `name` lets a built-in date variable get the calendar whatever type its
 * manifest entry carries: the Time/Date system group (`current_date`, `today`,
 * `current_month`, `current_year`) is typed "system", and legacy manifests type
 * catalogue dates such as `offer_expiry_date` as plain "input".
 */
export const getVariableControlKind = (
  type: string,
  name?: string,
): VariableControlKind =>
  name && isDateVariableName(name)
    ? "date"
    : (CONTROL_BY_TYPE[type] ?? "input");
